import { toast } from "react-toastify";
import axios from "axios";
import { Urls } from "../../../../../../Urls";
import { getCompanyFolderName } from "../../../../../../Utility";
import Axios from "../../../../../../Axios";
import { getmillisec, next_page } from "../Utility";
import { MastersChangeLog } from "../../../../Utility";

/**
 * Step 1 for file upload process in freight master bulk upload
 * Component for handling file upload, validation, and downloading standard format.
 */

export const uploadAndGetLocation = async (
  file,
  userDetails,
  companyProfile,
  setStep,
  setExcel_details,
  header_mapping,
) => {
  try {
    const ms = getmillisec();
    const ext = file.name.split(".").pop();
    const fileName = `${file.name.split(".")[0]}${ms}.${ext}`;
    const body = {
      fileName: `${getCompanyFolderName(userDetails?.email)}/${userDetails?.user_id}/${fileName}`,
      accountName: "lnclientdata",
      containerName: "freightmasteruploads",
      action: "upload",
    };

    const res = await axios.post(Urls.fileService, body);
    await axios.put(res.data.url, file, {
      headers: {
        "x-ms-blob-type": "blockblob",
        "x-ms-blob-content-disposition": file.type,
      },
    });

    setTimeout(async () => {
      const response = await Axios.get(
        `${Urls.freight_master}?field=excel_logs`,
      );
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        let current_excel_details = response.data.data.find(
          (obj) => obj?.module === "indent" && obj?.page !== "completed",
        );
        if (!current_excel_details) {
          current_excel_details = response.data.data[0];
        }

        localStorage.setItem("fm_excel_id", current_excel_details.excel_id);
        setExcel_details(current_excel_details);
        next_page({
          excel_id: current_excel_details.excel_id,
          updates: {
            module: "indent",
            header_mapping: header_mapping,
          },
        });
        setStep(2);
        // MastersChangeLog(
        //   "New File Uploaded",
        //   "freight_master",
        //   userDetails.email,
        //   userDetails.user_id,
        //   companyProfile.domain_data.company_id
        // );
      }
    }, 15000);

    return { status: "success" };
  } catch (error) {
    toast.error("Error while uploading your file");
    return { status: "failed", message: error };
  }
};

export const isSuperUser = (contact_info, email) => {
  let isSuperAdmin;
  let organizationList = [];
  if (contact_info && contact_info.length > 0) {
    contact_info.map((item) => {
      if (item.email === email) {
        if (item.super_admin && item.super_admin === true) {
          isSuperAdmin = true;
        } else {
          isSuperAdmin = false;
          if (item.organization && item.organization.length > 0) {
            organizationList = item.organization;
          }
        }
        if (item.organization && item.organization.length > 0) {
          organizationList = item.organization;
        }
      }
    });
  }
  return { isSuperAdmin, organizationList };
};
